export default "__VITE_ASSET__C3cCB6Zz__"